import { render, staticRenderFns } from "./jhi-hibar.vue?vue&type=template&id=ed53e074&scoped=true&"
import script from "./jhi-hibar.component.ts?vue&type=script&lang=ts&"
export * from "./jhi-hibar.component.ts?vue&type=script&lang=ts&"
import style0 from "./jhi-hibar.vue?vue&type=style&index=0&id=ed53e074&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed53e074",
  null
  
)

export default component.exports